import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import {BButton, BCard, BCollapse, BFormGroup, BFormInput, BTable, BTooltip, VBToggle} from "bootstrap-vue";

export default {
    name: "Havale",
    components: {
        FormModal,
        Loading,
        BTooltip, BButton, BCard, BTable, BCollapse, BFormGroup, BFormInput
    },
    directives: {
        'b-toggle': VBToggle,
    },
    mixins: [mixins],
    data() {
        return {
            url: 'admin/store_transfers',
            fields: [
                {
                    key: 'index',
                    label: 'ردیف'
                },
                {
                    key: 'id',
                    label: 'شناسه'
                },
                {
                    key: 'from_store_label',
                    label: 'انبار مبدا'
                },
                {
                    key: 'to_store_label',
                    label: 'انبار مقصد'
                },
                {
                    key: 'transmitter_full_name',
                    label: 'فروشنده'
                },
                {
                    key: 'created_at',
                    label: 'تاریخ ثبت'
                },
                {
                    key: 'show',
                    label: 'نمایش'
                },
            ],
        }
    },
    mounted() {
        this.loadItems()
    },
    methods: {
    }
}
